export default __webpack_public_path__ + "d62198124d485424907dca0f82f4340b.png";